module.exports = __webpack_public_path__ + "static/chinaVisa-adba41cfc5159ce8e9e380df196971f3.jpg";